/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import useMarketSnapshot from './use-market-snapshot'
import {Loading, Disclosures} from '../../twd/twd'
import Grid from './grid'
import RatingFieldset from '../rating-fieldset'

export default () => {

    const { tab, setTab, rating, setRating, rows, status } = useMarketSnapshot()

    return <React.Fragment>
    <div id="corporate-market-snapshot" className="vertical-offset-sm"></div>
    <div data-name="corporate-market-snapshot" className="container vertical-offset-sm" css={sectionCss}>
    <div className="row vertical-offset-sm"></div>

            <div className="row">
            <div className="col-md-6 col-xs-12">
                <h3 className="medium-header">Corporate Market Snapshot</h3>
            </div>

            <div className="col-md-6 col-xs-12">
            <RatingFieldset name='corporates-market-snapshot-rating'
                rating={rating} setRating={setRating} />
            </div>
            </div>

            <div className="row">
            <div className="col-md-12">
                <div data-name="corporate-market-snapshot-nav-tabs" className="nav-tabs">
                <ul>
                    <li className={tab==='MOST_ACTIVE_BUYS' ? 'active' : ''}>
                    <button
                        data-name="corporate-market-snapshot-most-active-buys-nav-tab"
                        onClick={() => setTab('MOST_ACTIVE_BUYS')}>Most active buys</button>
                    </li>

                    <li className={tab==='HIGHEST_RATIO' ? 'active' : ''}>
                    <button
                        data-name="corporate-market-snapshot-highest-buy-sell-ratio-nav-tab"
                        onClick={() => setTab('HIGHEST_RATIO')}>Highest buy/sell ratio</button>
                    </li>

                    <li className={tab==='LOWEST_RATIO' ? 'active' : ''}>
                    <button
                        data-name="corporate-market-snapshot-lowest-buy-sell-ratio-nav-tab"
                        onClick={() => setTab('LOWEST_RATIO')}>Lowest buy/sell ratio</button>
                    </li>
                </ul>
                </div>
            </div>
            </div>


        <Loading status={status}>
            <div className="row">
            <div className="col-xs-12">
                <Grid tab={tab} rows={rows} />
            </div>
            </div>

            <div className="row">
            <div className="col-xs-12 col-sm-8 text-small">
                Source: Tradeweb Direct LLC &amp; TRACE. Based on top 100 most actively traded issuers.
            </div>
            <div className="col-xs-12 col-sm-4 text-right">
                <Disclosures
                    dataName="corporate-market-snapshot-disclosures-link"
                    html={DISCLOSURES[tab] || ''} />
            </div>
            </div>
        </Loading>

        <div className="row vertical-offset-sm"></div>
        </div>
    </React.Fragment>

}

const DISCLOSURES = {
    MOST_ACTIVE_BUYS: `
    <p>This list displays the top 10 most actively purchased issuers in the retail markets.
    Note that the list only considers buy trades by retail investors, not sell trades.</p>
    `,

    HIGHEST_RATIO: `
    <p>This table displays the issuers in the retail market with the most positive momentum,
    as measured by the ratio of buy trades to sell trades. When a bond is popular among
    retail investors, it will have many buyers and few sellers.</p>

    <p>Bonds with substantially more buys than sells will appear on this list.</p>

    <p>In order to appear on this list, each firm has to be among the top 100
    most actively traded issuers in the retail market.</p>
    `,
    LOWEST_RATIO: `
    <p>This table displays the issuers in the retail market with the most negative momentum,
    as measured by the ratio of buy trades to sell trades.
    When a bond is out of favor with retail investors, it will have few buyers and many sellers.</p>

    <p>Bonds with substantially fewer buys than sells will appear on this list.</p>

    <p>In order to appear on this list, each firm has to be among the top 100
    most actively traded issuers in the retail market.</p>
    `
}


// WEBPACK FOOTER //
// ./src/corporates/market-snapshot/market-snapshot.js